/* Const,Let & Var will be here */
export const LOGO_SUCCESS = 'LogoSuccess';
export const LOGO_ERROR = 'LogoError';
export const APP_CONFIG = "AppConfig";
export const RESET_APP_CONFIG = "ResetAppConfig";
export const PROFILE_PICTURE = 'ProfilePicture';
export const REQUEST_APPLICATION_CONFIGURATION = 'requestApplicationConfiguration';
export const REQUEST_FAIL = "RequestFail";
/* Const,Let & Var will be here */

export function applicationMetaData(responseDataSuccess, applicationLogo, applicationName) {
    if (responseDataSuccess) {
        return {
            type: LOGO_SUCCESS,
            applicationLogo: applicationLogo,
            applicationName: applicationName
        };
    } else {
        return {
            type: LOGO_ERROR
        };
    }
}

export function requestApplicationConfiguration(partyRoleId, componentState) {
    return {
        type: REQUEST_APPLICATION_CONFIGURATION,
        requestData: {
            partyRoleId: partyRoleId,
            componentState: componentState
        }
    };
}

export function responseApplicationConfiguration(responseData) {
    if (parseInt(responseData.appConfig.maximumSkipLimit, 10) < parseInt(responseData.appConfig.take, 10)) {
        responseData.appConfig.take = responseData.appConfig.maximumSkipLimit
    }
    return {
        type: APP_CONFIG,
        responseData: responseData
    };
}

export function requestFail() {
    return {
        type: REQUEST_FAIL
    };
}

export function resetApplicationConfiguration() {
    return {
        type: RESET_APP_CONFIG
    };
}

export function profilePicture(profilePic) {
    return {
        type: PROFILE_PICTURE,
        profilePicture: profilePic
    };
}